import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';
import { trackPageViewFromTransition } from 'sh-www/utils/datalayer';

class ReferralReceiveRoute extends Route {
  @service calendly;

  model({ code }) {
    const controller = this.controllerFor('referral.receive');

    const calendly = this.calendly.load();

    return Promise.all([calendly, controller.findProjectdigestVerification(code)])
      .then(([calendly, projectdigestVerification]) => ({
        projectdigestVerification,
      }));
  }

  activate(transition) {
    super.activate(...arguments);
    trackPageViewFromTransition(this, transition, '/referral/receive/');
  }
}

export default ReferralReceiveRoute;
